import projectOptionsDetailsComponent from './project-options-details.component';

const projectOptionsDetailsModule = angular.module('projectOptionsDetails', [
])
  .component('projectOptionsDetails', projectOptionsDetailsComponent)
  .name;

export default projectOptionsDetailsModule;
